import { useEffect, useState } from 'react';
import http from '../services/httpService';
import useIsMounted from './useIsMounted';

export default function useBlog(_id) {
	const [blog, setBlog] = useState(null);
	const isMounted = useIsMounted();

	useEffect(() => {
		async function getBlogs() {
			try {
				if (!http.getCurrentUser()) return;
				const { data } = await http.getBlog(_id);
				if (isMounted()) setBlog(data);
			} catch (error) {
				console.log('error :>> ', error);
				if (isMounted()) setBlog('notFound');
			}
		}
		getBlogs();
	}, [isMounted, _id]);
	return [blog];
}
